var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSend = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 15,
  height: 14,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#0A78CD",
  d: "M.5 12.354V1.645q0-.478.385-.729a.83.83 0 0 1 .823-.063l12.709 5.334q.54.23.541.812 0 .585-.541.812L1.708 13.146a.83.83 0 0 1-.823-.064Q.5 12.833.5 12.354m1.75-1.312 9.562-4.043L2.25 2.957v2.771L7.25 7l-5 1.271z"
})));
export default SvgSend;